module.exports = __webpack_public_path__ + "img/79290557000164.67a9cf3a.png";